/**
 * Config: Breakpoints
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for media queries in scripts.
 * - This file is automatically generated by yarn design, do not edit.
 *
 */
// eslint-disable

export const values = {
  xs: 0,
  s: 576,
  m: 768,
  l: 1024,
  xl: 1366,
}

export default {
  xs: `${values.xs}px`,
  s: `${values.s}px`,
  m: `${values.m}px`,
  l: `${values.l}px`,
  xl: `${values.xl}px`,
}
